module.exports = __webpack_public_path__ + "img/lg_ring_y_c_null_1@3x.539df2d7.png";